import React from 'react';
import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;

const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.md};
  padding: ${props => props.theme.spacing.md};
  background-color: ${props => props.theme.colors.surface};
  border-radius: ${props => props.theme.borderRadius.md};
  box-shadow: ${props => props.theme.shadows.sm};
`;

const SkeletonLine = styled.div`
  height: ${props => props.height || '1rem'};
  width: ${props => props.width || '100%'};
  background-color: ${props => props.theme.colors.borderLight};
  border-radius: ${props => props.theme.borderRadius.sm};
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

const SkeletonCircle = styled.div`
  width: ${props => props.size || '40px'};
  height: ${props => props.size || '40px'};
  border-radius: 50%;
  background-color: ${props => props.theme.colors.borderLight};
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

const SkeletonCard = styled.div`
  width: ${props => props.theme.cardSize.width};
  height: ${props => props.theme.cardSize.height};
  background-color: ${props => props.theme.colors.card.background};
  border-radius: ${props => props.theme.cardSize.borderRadius};
  box-shadow: ${props => props.theme.colors.card.shadow};
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

const LoadingSkeleton = ({ type = 'line', count = 1, ...props }) => {
  switch (type) {
    case 'line':
      return (
        <SkeletonWrapper>
          {Array.from({ length: count }).map((_, index) => (
            <SkeletonLine key={index} {...props} />
          ))}
        </SkeletonWrapper>
      );
    case 'circle':
      return (
        <SkeletonWrapper>
          {Array.from({ length: count }).map((_, index) => (
            <SkeletonCircle key={index} {...props} />
          ))}
        </SkeletonWrapper>
      );
    case 'card':
      return (
        <SkeletonWrapper>
          {Array.from({ length: count }).map((_, index) => (
            <SkeletonCard key={index} {...props} />
          ))}
        </SkeletonWrapper>
      );
    default:
      return null;
  }
};

export default LoadingSkeleton;